import { TOGGLE_SELECT_ALL_DEVICE_GROUPS } from '../constants/actionTypes';
import { DeviceGroupsActionTypes } from '../types';

export const toggleSelectAllUnits = (isChecked: boolean): DeviceGroupsActionTypes => ({
  type: TOGGLE_SELECT_ALL_DEVICE_GROUPS,
  payload: isChecked,
});
